import { useState, useEffect } from 'react';
import { eventService } from '../services/apiService';
import EventList from '../components/EventList';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const fetchEvents = async () => {
    try {
      setLoading(true);
      setError('');
      const response = await eventService.getAllEvents();
      setEvents(response || []);
    } catch (err) {
      console.error('Fetch Events Error:', err);
      setError(err.message || 'Failed to fetch events');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  if (loading) {
    return <div className="text-center py-8">Loading events...</div>;
  }

  if (error) {
    return <div className="text-center py-8 text-red-500">{error}</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-2xl font-medium text-gray-800 mb-6">Event Management</h2>
      <EventList events={events} fetchEvents={fetchEvents} />
    </div>
  );
};

export default Events;